module.exports = __webpack_public_path__ + "assets/img/Slice 128.c5068fa1.png";